<template>
  <div class="slide" :id="anchor">
    <div class="title" :class="{ 'no-title': !title }">
      <h2 v-if="title">
        {{ title }}
      </h2>
    </div>
    <div class="content">
      <slot/>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'Slide',

    props: [
      'anchor',
      'title',
      'linkable',
    ],

    mounted() {
      const isLinkable = typeof(this.linkable) !== 'undefined';
      if(!isLinkable) {
        return;
      }

      this.$root.links.push({
        href: this.anchor,
        label: this.title,
      });
    },
  };
</script>

<style lang="less" scoped>
  @import (reference) '../shared.less';

  .slide {
    min-width: @slide-min-width;
    flex-grow: 1;
    box-sizing: border-box;
    padding: 0 @margins[long-h-padding];
    display: flex;
    flex-direction: column;

    @media @vertical {
      min-width: unset;
      padding: 0 @margins-v[long-h-padding];
      margin-top: @margins-v[long-v-padding] * 2;
    }

    @media @mobile {
      padding: 0 @margins-m[long-h-padding] * 3 0 @margins-m[long-h-padding];
    }

    @media @mobile-vertical {
      padding: 0 @margins-mv[long-h-padding];
      margin-top: @margins-mv[long-v-padding] * 2;
    }
  }

  .title {
    @basis: 17vh;
    @basis-v: 17vw;
    @basis-m: 15vh;
    @basis-mv: 15vw;

    flex-basis: @basis;
    flex-shrink: 0;
    z-index: @z-layers[slide-title];

    @media @vertical {
      flex-basis: @basis-v;
    }

    @media @mobile {
      flex-basis: @basis-m;
    }

    @media @mobile-vertical {
      flex-basis: @basis-mv;
      display: flex;
      justify-content: center;
    }

    h2 {
      @bad-space: 1.3;

      position: sticky;
      display: inline-block;
      left: @margins[long-h-padding] - (@bad-space * 1vh);
      margin: 0 0 0 (-@bad-space * 1vh);
      color: @colors[barely-visible];
      font-size: @font-sizes[header];
      line-height: @basis;
      font-family: @font-sets[header];

      @media @vertical {
        left: @margins-v[long-h-padding] - (@bad-space * 1vw);
        margin: 0 0 0 (-@bad-space * 1vw);
        font-size: @font-sizes-v[header];
        line-height: @basis-v;
      }

      @media @mobile {
        left: @margins-m[long-h-padding] - (@bad-space * 1vh);
        font-size: @font-sizes-m[header];
        line-height: @basis-m;
      }

      @media @mobile-vertical {
        left: @margins-mv[long-h-padding] - (@bad-space * 1vw);
        font-size: @font-sizes-mv[header];
        line-height: @basis-mv;
      }
    }
  }

  .no-title {
    @media @vertical {
      flex-basis: 2vw;
    }
  }

  .content {
    flex-grow: 1;
    display: flex;
    align-items: flex-start;
    z-index: @z-layers[slide-content];
  }
</style>
